import { render, staticRenderFns } from "./basket.vue?vue&type=template&id=03c9bf5d"
import script from "./basket.vue?vue&type=script&lang=js"
export * from "./basket.vue?vue&type=script&lang=js"
import style0 from "./basket.vue?vue&type=style&index=0&id=03c9bf5d&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c9bf5d')) {
      api.createRecord('03c9bf5d', component.options)
    } else {
      api.reload('03c9bf5d', component.options)
    }
    module.hot.accept("./basket.vue?vue&type=template&id=03c9bf5d", function () {
      api.rerender('03c9bf5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/sparepartcheckout/assets/frontend/components/basket.vue"
export default component.exports